import React from "react";
import vertical_shot_buildings1 from "../../assets/verticalshotcity_sidebarBackground.svg";
import person1 from "../../assets/person1.png";
import person2 from "../../assets/person2.png";
import person3 from "../../assets/person3.png";
import person4 from "../../assets/person4.png";
import person5 from "../../assets/person5.png";
import person6 from "../../assets/person6.png";
import person7 from "../../assets/person7.png";
import person8 from "../../assets/person8.png";
import { useTranslation } from "react-i18next";

export default function Team() {
  const { t } = useTranslation();

  return (
    <section
      className="relative bg-cover bg-center bg-no-repeat pt-5 pb-9"
      style={{
        backgroundImage: `linear-gradient(to bottom, #f6fcff 0%, rgba(6, 53, 6, 0.35) 80%), url(${vertical_shot_buildings1})`,
      }}
    >
      <div className="mx-auto max-w-7xl px-6 text-center text-white">
        <h2 className="font-arya text-3xl font-extrabold tracking-tight text-gray-900">
          {t("about.team.title")}
        </h2>

        {/* Danish Office */}
        <h3 className="mt-8 sm:mt-10 text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-[#0D4724]">
          THE DANISH OFFICE
        </h3>
        <div className="mt-10 grid grid-cols-1 gap-10 sm:grid-cols-2 md:grid-cols-4">
          <div className="flex flex-col items-center">
            <img
              src={person1}
              alt="Tariq Kajjouj"
              className="h-40 w-40 object-cover"
            />
            <p className="mt-4 font-bold text-[#0D4724]">TARIQ KAJJOUJ</p>
            <p className="text-sm text-[#0D4724]">Founder & CEO</p>
          </div>

          <div className="flex flex-col items-center">
            <img
              src={person3}
              alt="Morten Jacobsen"
              className="h-40 w-40 object-cover"
            />
            <p className="mt-4 font-bold text-[#0D4724]">MORTEN JACOBSEN</p>
            <p className="text-sm text-[#0D4724]">
              Founder & Construction Specialist
            </p>
          </div>

          <div className="flex flex-col items-center">
            <img
              src={person2}
              alt="Sarah W. Høyer"
              className="h-40 w-40 object-cover"
            />
            <p className="mt-4 font-bold text-[#0D4724]">SARAH W. HØYER</p>
            <p className="text-sm text-[#0D4724]">COO & Administration</p>
          </div>

          <div className="flex flex-col items-center">
            <img
              src={person4}
              alt="Dalia R. Mathiase"
              className="h-40 w-40 object-cover"
            />
            <p className="mt-4 font-bold text-[#0D4724]">DALIA R. MATHIASE</p>
            <p className="text-sm text-[#0D4724]">Partner & Investor</p>
          </div>
        </div>

        {/* Moroccan Office */}
        <h3 className="mt-20 sm:mt-10 text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-[#0D4724]">
          THE MOROCCAN OFFICE
        </h3>
        <div className="mt-10 grid grid-cols-1 gap-10 sm:grid-cols-2 md:grid-cols-4">
          <div className="flex flex-col items-center">
            <img
              src={person5}
              alt="Omar Ait Bouziaren"
              className="h-40 w-40 object-cover"
            />
            <p className="mt-4 font-bold text-[#FFFFFF]">OMAR AIT BOUZIAREN</p>
            <p className="text-sm text-[#FFFFFF]">
              Product Development Team Leader
            </p>
          </div>

          <div className="flex flex-col items-center">
            <img
              src={person7}
              alt="Issam Fathi"
              className="h-40 w-40 object-cover"
            />
            <p className="mt-4 font-bold text-[#FFFFFF]">ISSAM FATHI</p>
            <p className="text-sm text-[#FFFFFF]">AI Training Agent</p>
          </div>

          <div className="flex flex-col items-center">
            <img
              src={person6}
              alt="Radwa Ajdour"
              className="h-40 w-40 object-cover"
            />
            <p className="mt-4 font-bold text-[#FFFFFF]">RADWA AJDOUR</p>
            <p className="text-sm text-[#FFFFFF]">AI Training Agent</p>
          </div>

          <div className="flex flex-col items-center">
            <img
              src={person8}
              alt="Hamza Khadiri"
              className="h-40 w-40 object-cover"
            />
            <p className="mt-4 font-bold text-[#FFFFFF]">HAMZA KHADIRI</p>
            <p className="text-sm text-[#FFFFFF]">AI Training Agent</p>
          </div>
        </div>
      </div>
    </section>
  );
}
